/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import Heading from '@coop/ole/Heading';
import Paragraph from '@coop/ole/Paragraph';
import DesertImage from '@coop/ole/DesertImage';
import styled from 'styled-components';
import { SUPPORT_PHONE_NUMBER } from '@coop/constants/generic';

import { Button } from '@coop/ole/Button';
import { colors } from '@coop/ole/styles/colors';
import { Trans } from '@lingui/macro';

import { Page } from 'src/components/Page';

const Wrapper = styled.div`
  padding-top: 10vh;
  padding-bottom: 20vh;
  text-align: center;
`;

const Illustration = styled(DesertImage)`
  margin: 20px;
`;

const Text = styled(Paragraph)`
  padding: 10px;
`;

const Support = styled.span`
  color: ${colors.brandPurple};
`;

const Separator = styled.hr`
  width: 350px;
  border-style: solid;
  border-color: transparent;
  border-top-color: ${colors.grey20};
`;

interface EventTracking {
  trackEvent?: () => void;
}

interface BackLink {
  backLink: string;
}

type NotFoundProps = BackLink & EventTracking;

const NotFound: React.FC<NotFoundProps> = (props) => {
  const trackAndRedirect = () => {
    props.trackEvent && props.trackEvent();
    window.location.replace(props.backLink || '/');
  };

  return (
    <Page>
      <Wrapper>
        <Illustration />
        <Heading size={2}>
          <Trans>Not Found</Trans>
        </Heading>
        <Text>
          <Trans>
            We had a little trouble finding this page. <br />
            Please try again. If this continues, please <br />
            contact us at{' '}
            <Support>{SUPPORT_PHONE_NUMBER.humanReadable}</Support>.
          </Trans>
        </Text>
        <Separator />
        <Button inline={true} onClick={trackAndRedirect}>
          <Trans>Go Back</Trans>
        </Button>
      </Wrapper>
    </Page>
  );
};

export default NotFound;
